export default __webpack_public_path__ + "static/tip1-c28206408a72fc1a33b1df9e5366e717.png";